// removed by extract-text-webpack-plugin
module.exports = {"container":"_2SQei4d2GgfZW_G-v6dnZy","input":"etGPNuZiqdax6XjPk1iOF"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Prepare/Field/Menu/Value/Text/styles.css
// module id = 3102
// module chunks = 0